import { Navigate, useLocation } from 'react-router'
import { useAuthStore } from '@/store/authStore'

interface PermissionRouteProps {
  /** 单个权限码 */
  permission?: string
  /** 任一命中即可 */
  anyOf?: string[]
  /** 全部命中才可 */
  allOf?: string[]
  children: React.ReactNode
}

/**
 * 路由级权限守卫。必须挂在 ProtectedRoute(认证)之内。
 *
 * - 未登录 → 由外层 ProtectedRoute 兜底跳登录页,本组件不再处理。
 * - 已登录但无权限 → 跳 /403。
 * - 持有 "*" 通配 → 直接放行。
 */
export function PermissionRoute({ permission, anyOf, allOf, children }: PermissionRouteProps) {
  const permissions = useAuthStore((s) => s.permissions)
  const location = useLocation()

  const allowed = (() => {
    if (!permissions || permissions.length === 0) return false
    if (permissions.includes('*')) return true
    if (permission && !permissions.includes(permission)) return false
    if (anyOf && anyOf.length > 0 && !anyOf.some((c) => permissions.includes(c))) return false
    if (allOf && allOf.length > 0 && !allOf.every((c) => permissions.includes(c))) return false
    return true
  })()

  if (!allowed) {
    return <Navigate to="/403" state={{ from: location }} replace />
  }
  return <>{children}</>
}
